import {SidebarSponsors as SponsorsComponent} from '@github-ui/code-view-sidebar/components/SidebarSponsors'
import type {SidebarSponsorsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarSponsors({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'sponsors', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/sponsors`)
      if (!r.ok) throw new Error(`Sidebar sponsors fetch failed (${r.status})`)
      return (await r.json()) as SidebarSponsorsResponse
    },
  })

  if (!data) return null
  return <SponsorsComponent {...data} />
}
